/**
 * CloudGraph entity ATI constants used by third-party product configs.
 * This file contains only the CloudGraph entities needed for 3P configs.
 * 1P entities (Atlas, Mercury, Confluence, Jira, etc.) remain in search-page.
 */
import type { CloudGraphDocumentEntityAti } from '@atlassian/search-client/common/types';

export const DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI: CloudGraphDocumentEntityAti[] = [
	'ati:cloud:graph:document',
];
